import type { CSSProperties } from 'react';

/** Shared pill shape/typography for status chips, so availability and other
 *  status pills (e.g. the eligibility chip) sit together at the same size. */
export const STATUS_CHIP_BASE_CLASS =
  'inline-flex items-center justify-center gap-2 rounded-lg text-sm font-medium whitespace-nowrap';

/** Shared pill dimensions for status chips (paired with STATUS_CHIP_BASE_CLASS). */
export const STATUS_CHIP_SIZE_STYLE: CSSProperties = {
  minWidth: 91,
  height: 32,
  paddingTop: 8,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
};
